import { SearchResult, SectionId } from "@/pages/SearchIndexPage/types";
import { SearchIndexResponse } from "@/web-client/api";
import { useMemo } from "react";

type SearchIndexResults = {
  results: SearchResult[];
  noResult: boolean;
};

const useSearchIndexResults = (
  data: SearchIndexResponse,
): SearchIndexResults => {
  const results = useMemo<SearchResult[]>(() => {
    if (!data) return [];

    return [
      {
        section_id: SectionId.Team,
        label: "チーム",
        count: data.teams_total_count,
        items: data.teams,
      },
      {
        section_id: SectionId.Maker,
        label: "メーカー",
        count: data.makers_total_count,
        items: data.makers,
      },
      {
        section_id: SectionId.List,
        label: "リスト",
        count: data.lists_total_count,
        items: data.lists,
      },
      {
        section_id: SectionId.Board,
        label: "マテリアルボード",
        count: data.boards_total_count,
        items: data.boards,
      },
      {
        section_id: SectionId.BuildingMaterial,
        label: "建材",
        count: data.building_materials_total_count,
        items: data.building_materials,
      },
      {
        section_id: SectionId.Interior,
        label: "家具",
        count: data.interiors_total_count,
        items: data.interiors,
      },
      {
        section_id: SectionId.Project,
        label: "プロジェクト",
        count: data.projects_total_count,
        items: data.projects,
      },
      {
        section_id: SectionId.Post,
        label: "事例写真",
        count: data.posts_total_count,
        items: data.posts,
      },
    ];
  }, [data]);

  const noResult = useMemo(
    () => !results.some((result) => result.count > 0),
    [results],
  );

  return {
    results,
    noResult,
  };
};
export default useSearchIndexResults;
